import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const FirebasePaginator = ({
  ChildComponent,
  reverse = false,
  pageSize = 10,
  childProps,
  firebaseQuery,
  urlPath,
  urlParams = "",
  nextText = "Next",
  prevText = "Previous",
}) => {
  const { page } = useParams();
  const [prelElements, setPrelElements] = useState([]);
  const [elements, setElements] = useState([]);
  const [actual_page, setActualPage] = useState(1);
  const [existNextPage, setExistNextPage] = useState(true);
  const [prevFilter, setPrevFilter] = useState("");
  const setedPageSize = pageSize + 1;

  useEffect(() => {
    if (page > 0) {
      /**< Check if is need to render again, due to a new query */
      let isNewQuery = false;
      const path = firebaseQuery.queryParams_.index_.indexPath_.pieces_;
      if (
        (path[0] === "search_en" ||
          path[0] === "search_esp" ||
          path[1] === "updateDate") &&
        prevFilter !== firebaseQuery.queryParams_.indexStartValue_
      ) {
        isNewQuery = true;
        setPrevFilter(firebaseQuery.queryParams_.indexStartValue_);
      } else if (path[1] === "tags" && prevFilter !== path[2]) {
        isNewQuery = path[2];
        setPrevFilter(path[2]);
      } else if (
        path[0] === "entryType" &&
        prevFilter !== firebaseQuery.queryParams_.indexStartValue_
      ) {
        isNewQuery = firebaseQuery.queryParams_.indexStartValue_;
        setPrevFilter(firebaseQuery.queryParams_.indexStartValue_);
      }
      /** Check if is need to render again, due to a new query >*/

      firebaseQuery
        .limitToFirst(page * setedPageSize)
        .on("value", (snapshot) => {
          if (snapshot.val()) {
            if (actual_page !== parseInt(page)) {
              setActualPage(parseInt(page));
              setPrelElements([]);
            }
            if (prelElements.length === 0 || isNewQuery) {
              setPrelElements(snapshot.val());
              let elementsToPaginate = Object.keys(snapshot.val());
              if (reverse) {
                elementsToPaginate = elementsToPaginate.reverse();
              }
              const filteredElements = elementsToPaginate
                .filter((key, i) => {
                  return (
                    i >= page * setedPageSize - setedPageSize - 1 &&
                    i < page * setedPageSize - 1
                  );
                })
                .map((key) => {
                  const value = snapshot.val()[key];
                  return { key, value };
                });
              isNewQuery = false;

              setElements(filteredElements);
            }
          }
        });
      if (Object.keys(prelElements).length !== page * setedPageSize) {
        setExistNextPage(false);
      } else {
        setExistNextPage(true);
      }
    }
  }, [
    firebaseQuery,
    setExistNextPage,
    actual_page,
    prelElements,
    elements,
    page,
    setedPageSize,
    reverse,
    pageSize,
    prevFilter,
  ]);

  return (
    <>
      <div className="elements-container">
        <ChildComponent data={elements} {...childProps} />
      </div>
      <div className="pag-controls">
        {page > 1 && (
          <Link
            to={`${urlPath}/${actual_page - 1}${urlParams}`}
            className="btn prev"
          >
            {prevText}
          </Link>
        )}

        {existNextPage && (
          <Link
            to={`${urlPath}/${actual_page + 1}${urlParams}`}
            className="btn next"
          >
            {nextText}
          </Link>
        )}
      </div>
    </>
  );
};

export default FirebasePaginator;
